import React, {FC, useState} from "react";
import {StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useConsumerSendMailMutation} from "../../Queries";
import {isValidEmail} from "../../components/Validations";
import clsx from "clsx";
import {Theme} from "@mui/material";
import {useRecoilValue} from "recoil";
import {DropOffIcon, PackItIcon, TradeInIcon} from "../../svg/SvgIcons";
import {LocalizationsAtom} from "../../providers/localization/LocalizationProvider";

export const SkagenClothingPage: FC<any> = () => {
   const [sent, setSent] = useState<boolean>(false)
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useStyles({
      leftImage: localizations.frontPageImage1 || "url('https://skagen-clothing.dk/cdn/shop/files/3_e26060c3-8132-4b04-b857-fb7ee8f5e277.jpg?v=1699441407&width=600')",
      rightImage: localizations.frontPageImage2 || "url('https://skagen-clothing.dk/cdn/shop/files/Design_uden_navn_32.jpg?v=1702313272&width=600')",
   });

   const onSent = () => {
      setSent(true)
   }


   return <div>
      <StyledDiv type={"main"} className={classes.container}>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.leftImage)}>
            &nbsp;
         </StyledDiv>
         <StyledDiv type={"contrast"} className={classes.main}>
            <div className={classes.content}>
               {!sent && <>
                  <StyledTypography variant={"h1"} type={"main"} style={{marginBottom: '26px'}}>
                     {localizations.loginPageTitle}
                  </StyledTypography>
                  <StyledTypography variant={"body1"} type={"main"} style={{marginBottom: '20px'}}>
                     {localizations.loginPageDescription}<br/>
                     {localizations.loginPageDescription2}
                  </StyledTypography>
               </>}
               <div className={classes.accessForm}>
                  <AccessForm onSent={onSent}/>
               </div>
            </div>
         </StyledDiv>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.rightImage)}>
            &nbsp;
         </StyledDiv>
      </StyledDiv>
      <SkagenEasyBox/>
   </div>
}

type imageProps = {
   leftImage: string
   rightImage: string
}

const useStyles = makeStyles({
   backContainer: {
      marginTop: '20px'
   },
   content: {
      maxWidth: '500px',
      textAlign: 'center'
   },
   container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'top',
      padding: '0 40px 0 40px'
   },
   accessForm: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '20px'
   },
   image: {
      width: '400px',
      minHeight: '496px',
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "top center",
      overflowX: 'hidden',
      overflowY: 'hidden',
   },
   main: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      padding: '50px'
   },
   leftImage: {
      backgroundImage: (props: imageProps) => props.leftImage
   },
   rightImage: {
      backgroundImage: (props: imageProps) => props.rightImage
   },
   '@media only screen and (max-width: 800px)': {
      container: {
         flexDirection: 'column',
         padding: '0 23px 0 23px'
      } as any,
      image: {
         width: '100%',
         maxHeight: '200px',
         minHeight: '300px',
         backgroundPosition: "center",
      }
   },
   '@media only screen and (max-width: 1024px)': {
      container: {
         padding: '0 23px 0 23px'
      } as any
   },
})

type AccessFormProps = {
   onSent: () => void
}

export const AccessForm = ({onSent}: AccessFormProps) => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [email, setEmail] = React.useState<string>('');
   const [sent, setSent] = React.useState<boolean>(false);

   const classes = useAccessFormStyles();
   const [sendMail] = useConsumerSendMailMutation();

   const onChange = (event: any) => {
      setEmail(event.target.value);
      setSent(false);
   }

   const onSend = async () => {
      let shopId = window.shopId || window.brandId;
      if (!!email && isValidEmail(email)) {
         await sendMail({
            variables: {
               shopId: shopId,
               mail: email
            }
         });
         setEmail('');
         setSent(true);
         onSent()
      }
   }

   return <>
      {!sent &&
         <form className={classes.lightBoxInputArea} onSubmit={async (e) => {
            e.preventDefault();
            await onSend();
         }}>
            <div className={"form-control w3_bg"}>
               <input
                  style={{paddingTop: "0px", minWidth: "300px", border: "2px solid #1F2845"}}
                  className={"input is-floating"}
                  id="loginemail"
                  type="email"
                  value={email}
                  onChange={onChange}
                  placeholder={localizations.mainPageEnterEmail}
                  aria-haspopup={false}
                  autoComplete={"off"}
                  required
               />
               <label htmlFor="loginemail" className="floating-label">E-mail</label>
               <div className="self-submit-button w3_bg">
                  <button type="submit" className="circle-chevron hover:colors">
                     <span className="sr-only">Send login</span>
                     <svg role="presentation" focusable="false" width="5" height="8"
                          className="icon icon-chevron-right-small reverse-icon" viewBox="0 0 5 8">
                        <path d="m.75 7 3-3-3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
                     </svg>
                  </button>
               </div>
            </div>
         </form>}
      {sent && <div className={classes.emailSent}>
         <StyledTypography variant={"h1"} className={classes.emailSentDivider}
                           type={"main"}>{localizations.mainPageMailSent}</StyledTypography>
         <StyledTypography variant={"body1"} type={"main"}>{localizations.mainPageMailSent2}</StyledTypography>
      </div>}
   </>
}


const useAccessFormStyles = makeStyles({
   input: {
      width: '100%',
      height: '45px',
      borderRadius: '20px',
      minWidth: '300px'
   },
   button: {
      height: '45px'
   },
   lightBoxInputArea: {
      display: 'flex',
      alignItems: 'center'
   },
   lightBoxMaxWidth: {
      maxWidth: '60%',
      margin: '0 auto'
   },
   emailSent: {
      marginTop: '20px',
      textAlign: 'center',
      padding: '20px'
   },
   emailSentDivider: {
      marginBottom: '15px'
   },
});


const SkagenEasyBox = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useEasyStyles();
   return <div className={classes.container}>
      <div>
         <StyledTypography variant={"h1"} className={classes.title}>
            {localizations.easyBoxTitle}
         </StyledTypography>
      </div>
      <div>
         <div className={classes.list}>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <TradeInIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection1Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection1Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <PackItIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection2Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection2Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <DropOffIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection3Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection3Description}
                  </StyledTypography>
               </div>
            </div>
         </div>
      </div>
   </div>
}


const useEasyStyles = makeStyles((theme: Theme) => ({
      container: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center'
      },
      title: {
         marginTop: '40px'
      },
      text: {
         marginBottom: '15px'
      },
      list: {
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         marginTop: '40px'
      },
      listItem: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         marginBottom: '20px',
         gap: '10px'
      },
      listAvatar: {},
      listText: {
         marginTop: '0',
         textAlign: 'center',
         maxWidth: '400px',
         padding: '0 20px 0 20px'
      },
      '@media only screen and (max-width: 800px)': {
         list: {
            flexDirection: 'column',
         },
         listItem: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '600px',
            gap: '10px'
         },
      }
   }),
);
